import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import FusionCharts from "fusioncharts";
import FusionMaps from "fusioncharts/fusioncharts.maps";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import USA from "fusionmaps/maps/fusioncharts.usa";
import Alabama from "fusionmaps/maps/fusioncharts.alabama";
import AlaskaCustomMapCurrent from "./CustomMaps/AlaskaMap_2022-present";
import AlaskaMap_20162022 from "./CustomMaps/AlaskaMap_2016-2022";
import AlaskaMap_20142015 from "./CustomMaps/AlaskaMap_2014-2015";
import AlaskaMap_19942013 from "./CustomMaps/AlaskaMap_1994-2013";
import AmericanSamoaMap from "./CustomMaps/AmericaSamoa";
import Arizona from "fusionmaps/maps/fusioncharts.arizona";
import Arkansas from "fusionmaps/maps/fusioncharts.arkansas";
import California from "fusionmaps/maps/fusioncharts.california";
import Colorado from "fusionmaps/maps/fusioncharts.colorado";
import ConnecticutCustomMap from "./CustomMaps/ConnecticutMap";
import Connecticut from "fusionmaps/maps/fusioncharts.connecticut";
import DistrictOfColumbiaModified from "./CustomMaps/DistrictOfColumnbia";
import Delaware from "fusionmaps/maps/fusioncharts.delaware";
import Florida from "fusionmaps/maps/fusioncharts.florida";
import Georgia from "fusionmaps/maps/fusioncharts.georgia";
import Hawaii from "fusionmaps/maps/fusioncharts.hawaii";
import Idaho from "fusionmaps/maps/fusioncharts.idaho";
import Illinois from "fusionmaps/maps/fusioncharts.illinois";
import Indiana from "fusionmaps/maps/fusioncharts.indiana";
import Iowa from "fusionmaps/maps/fusioncharts.iowa";
import Kansas from "fusionmaps/maps/fusioncharts.kansas";
import Kentucky from "fusionmaps/maps/fusioncharts.kentucky";
import Louisiana from "fusionmaps/maps/fusioncharts.louisiana";
import Maine from "fusionmaps/maps/fusioncharts.maine";
import Maryland from "fusionmaps/maps/fusioncharts.maryland";
import Massachusetts from "fusionmaps/maps/fusioncharts.massachusetts";
import Michigan from "fusionmaps/maps/fusioncharts.michigan";
import Minnesota from "fusionmaps/maps/fusioncharts.minnesota";
import Mississippi from "fusionmaps/maps/fusioncharts.mississippi";
import Missouri from "fusionmaps/maps/fusioncharts.missouri";
import Montana from "fusionmaps/maps/fusioncharts.montana";
import Nebraska from "fusionmaps/maps/fusioncharts.nebraska";
import Nevada from "fusionmaps/maps/fusioncharts.nevada";
import NewHampshire from "fusionmaps/maps/fusioncharts.newhampshire";
import NewJersey from "fusionmaps/maps/fusioncharts.newjersey";
import NewMexico from "fusionmaps/maps/fusioncharts.newmexico";
import NewYork from "fusionmaps/maps/fusioncharts.newyork";
import NorthCarolina from "fusionmaps/maps/fusioncharts.northcarolina";
import NorthDakota from "fusionmaps/maps/fusioncharts.northdakota";
import NorthernMarianaIslands from "./CustomMaps/NorthernMarianaIslands";
import Ohio from "fusionmaps/maps/fusioncharts.ohio";
import Oklahoma from "fusionmaps/maps/fusioncharts.oklahoma";
import Oregon from "fusionmaps/maps/fusioncharts.oregon";
import Pennsylvania from "fusionmaps/maps/fusioncharts.pennsylvania";
import RhodeIsland from "fusionmaps/maps/fusioncharts.rhodeisland";
import SouthCarolina from "fusionmaps/maps/fusioncharts.southcarolina";
import SouthDakota from "fusionmaps/maps/fusioncharts.southdakota";
import Tennessee from "fusionmaps/maps/fusioncharts.tennessee";
import Texas from "fusionmaps/maps/fusioncharts.texas";
import Utah from "fusionmaps/maps/fusioncharts.utah";
import Vermont from "fusionmaps/maps/fusioncharts.vermont";
import VirginiaMap19942013 from "./CustomMaps/VirginiaMap_1994-2013";
import VirginiaMap2014present from "./CustomMaps/VirginiaMap_2014-present";
import Washington from "fusionmaps/maps/fusioncharts.washington";
import WestVirginia from "fusionmaps/maps/fusioncharts.westvirginia";
import Wisconsin from "fusionmaps/maps/fusioncharts.wisconsin";
import Wyoming from "fusionmaps/maps/fusioncharts.wyoming";
import React from "react";
import ReactFC from "react-fusioncharts";
import { fetchData } from "../../common/services/ApiClient";
import { ApiBaseUrl } from "../../config";
import { KeyValue, Query } from "../../interfaces";
import HeatBoxIcon from "./HeatBoxIcon";
import { licenseKey } from "./license";
import { territoryMapping, getMapType } from "./utilities";
import Guamcongressional from "fusionmaps/maps/fusioncharts.guamcongressional";
import Micronesia from "fusionmaps/maps/fusioncharts.micronesia";
import Marshallisland from "fusionmaps/maps/fusioncharts.marshallisland";
import Palau from "fusionmaps/maps/fusioncharts.palau";
import Puertorico from "fusionmaps/maps/fusioncharts.puertorico";
import USVirginIsland from "fusionmaps/maps/fusioncharts.usvirginisland";
import { selectedStatesAlpha } from "../../refdata/FilterOptions";

const PREFIX = "USAMap";

const classes = {
  cardDisplay: `${PREFIX}-cardDisplay`,
  statesHeading: `${PREFIX}-statesHeading`,
  territory: `${PREFIX}-territory`,
};

const Root = styled("div")<{
  $isCountyView: boolean;
  dontShowCountyData: boolean;
}>(({ theme, $isCountyView, dontShowCountyData }) => ({
  [`& .${classes.cardDisplay}`]: {
    "border": `1px solid ${theme.palette.primary.main}`,
    "borderRadius": 8,
    "color": theme.palette.primary.main,
    "& .MuiTypography-body1": {
      fontSize: ".875rem",
      lineHeight: "1rem",
      paddingBottom: ".5rem",
    },
    "& .MuiCardContent-root": {
      padding: "1rem .5rem .5rem .5rem",
    },
  },

  [`& .${classes.statesHeading}`]: {
    position: "relative",
    color: theme.palette.primary.main,
    fontSize: "1rem",
    fontWeight: "bolder",
    paddingLeft: 0,
    textAlign: "left",
    paddingBottom: 7,
  },

  [`& .${classes.territory}`]: {
    "& .MuiTypography-body2": {
      fontSize: ".875rem",
      whiteSpace: "nowrap",
      paddingTop: 2,
      fontWeight: 400,
      paddingBottom: 0,
      cursor: $isCountyView ? "default" : "pointer",
    },
  },
  "& .fusioncharts-container svg g path": {
    cursor: !dontShowCountyData ? "pointer" : "default",
  },

  "& .fusioncharts-container svg [class^='raphael-group-'] rect": {
    cursor: $isCountyView ? "default" : "pointer",
    ["cursor" as any]: `${$isCountyView ? "default" : "pointer"} !important`,
  },
  "& .fusioncharts-container svg g[cursor='pointer'][fill='#b1b2b7']": {
    display: "none",
  },
}));

interface MapData {
  id: string;
  value: number;
}

interface Props {
  appState: Query;
  mapData: MapData[];
  usaTotal: number;
  updateFilter: (field: string, value: string | string[]) => void;
  setMode: React.Dispatch<React.SetStateAction<"table" | "map">>;
}

(FusionCharts as any).options["license"]({
  key: licenseKey,
  creditLabel: false,
});

ReactFC.fcRoot(
  FusionCharts,
  FusionMaps,
  USA,
  FusionTheme,
  Alabama,
  AlaskaMap_19942013,
  AlaskaMap_20142015,
  AlaskaMap_20162022,
  AlaskaCustomMapCurrent,
  AmericanSamoaMap,
  Arizona,
  Arkansas,
  California,
  Colorado,
  Connecticut,
  ConnecticutCustomMap,
  DistrictOfColumbiaModified,
  Delaware,
  Florida,
  Georgia,
  Guamcongressional,
  Hawaii,
  Idaho,
  Illinois,
  Indiana,
  Iowa,
  Kansas,
  Kentucky,
  Louisiana,
  Maine,
  Marshallisland,
  Maryland,
  Massachusetts,
  Michigan,
  Micronesia,
  Minnesota,
  Mississippi,
  Missouri,
  Montana,
  Nebraska,
  Nevada,
  NewHampshire,
  NewJersey,
  NewMexico,
  NewYork,
  NorthCarolina,
  NorthDakota,
  NorthernMarianaIslands,
  Ohio,
  Oklahoma,
  Oregon,
  Palau,
  Pennsylvania,
  Puertorico,
  RhodeIsland,
  SouthCarolina,
  SouthDakota,
  Tennessee,
  Texas,
  USVirginIsland,
  Utah,
  Vermont,
  VirginiaMap19942013,
  VirginiaMap2014present,
  Washington,
  WestVirginia,
  Wisconsin,
  Wyoming,
);

export const handleMouseOver = (
  label: string,
  shortLabel: string,
  stateElement: KeyValue,
  usaTotalsElement: KeyValue,
  totalsByState: KeyValue,
) => {
  if (stateElement && stateElement.current) {
    stateElement.current.innerText = label;
  }

  if (usaTotalsElement && usaTotalsElement.current && shortLabel) {
    usaTotalsElement.current.innerText = totalsByState[shortLabel]
      ? `${totalsByState[shortLabel].toLocaleString()}`
      : "0";
  }
  return {
    state: stateElement,
    branches: usaTotalsElement,
  };
};

export const handleMouseOut = (
  stateElement: KeyValue,
  usaTotal: number,
  usaTotalsElement: KeyValue,
) => {
  if (stateElement && stateElement.current) {
    stateElement.current.innerText = "All States and Territories";
  }
  if (usaTotalsElement && usaTotalsElement.current) {
    usaTotalsElement.current.innerText = `${usaTotal.toLocaleString()}`;
  }

  return {
    state: stateElement,
    branches: usaTotalsElement,
  };
};

export default function USAMap({
  appState,
  mapData,
  usaTotal,
  updateFilter,
  setMode,
}: Props) {
  const [countyNameByCodeLookup, setCountyNameByCodeLookup] = React.useState<
    Record<string, string>
  >({});
  const stateElement = React.useRef<HTMLInputElement>(
    document.createElement("state") as HTMLInputElement,
  );
  const usaTotalsElement = React.useRef<HTMLInputElement>(null);
  const totalsByState: KeyValue = mapData.reduce((a, c) => {
    return { ...a, [c.id]: c.value };
  }, {});

  const [legendRangeMinValue, setLegendRangeMinValue] = React.useState(0);
  const [legendRangeMaxValue, setLegendRangeMaxValue] =
    React.useState(38000000000000);
  const [countyMidMax, setCountyMidMax] = React.useState({
    low: 0,
    mid: 10000000,
    max: 20000000,
  });
  const max = Math.max(...mapData.map((d) => d.value));
  const stateMidMax = {
    low: 0,
    mid: Math.floor(max / 2),
    max: max,
  };

  const handleRangeUpdated = (eventObj: KeyValue) => {
    setLegendRangeMinValue(eventObj.data.minValue);
    setLegendRangeMaxValue(eventObj.data.maxValue);
  };
  const usStatesAndTerritories = [
    { abbr: "AS", label: "American Samoa" },
    {
      abbr: "FM",
      label: "Federated States of Micronesia",
      altLabel: "F.S. of Micronesia",
    },
    { abbr: "DC", label: "District of Columbia" },
    { abbr: "DE", label: "Delaware" },
    { abbr: "GU", label: "Guam" },
    { abbr: "MH", label: "Marshall Islands" },
    { abbr: "MP", label: "Northern Mariana Islands" },
    { abbr: "PW", label: "Palau" },
    { abbr: "PR", label: "Puerto Rico" },
    { abbr: "RI", label: "Rhode Island" },
    { abbr: "VI", label: "US Virgin Islands" },
    { abbr: "Foreign Branch Offices", label: "Foreign Branch Offices" },
  ];

  const [selectedStateAbbr, setSelectedStateAbbr] = React.useState<
    string | null
  >(appState.filters.stalpbr || null);
  const statesWithNoCounties = new Set(["MP", "Foreign Branch Offices"]);
  const dontShowCountyData: boolean =
    selectedStateAbbr && statesWithNoCounties.has(selectedStateAbbr)
      ? true
      : false;

  const [selectedState, setSelectedState] = React.useState<string | null>(
    appState.filters.stalpbr
      ? (usStatesAndTerritories.find((t) => t.abbr === appState.filters.stalpbr)
          ?.label ?? appState.filters.stalpbr)
      : null,
  );
  const [mapType, setMapType] = React.useState<string>(
    appState.filters.stalpbr &&
      getMapType(appState.filters.stalpbr, appState.ui.year)
      ? getMapType(appState.filters.stalpbr, appState.ui.year)
      : "maps/usa",
  );
  const [countyBranchesById, setCountyBranchesById] = React.useState<
    Record<string, number>
  >({});
  const [countyMapData, setCountyMapData] = React.useState<KeyValue[]>([]);
  const [chartId, setChartId] = React.useState(`usa-map-${Date.now()}`);
  const isCountyView = Boolean(appState.filters.stalpbr !== "");

  const handleCountyMouseOver = (countyLabel: string, countyId: string) => {
    if (dontShowCountyData) return;
    const normalizedId = countyId.split(".").join(".");
    if (stateElement?.current) {
      stateElement.current.innerText =
        countyNameByCodeLookup[countyId] ?? countyLabel;
    }
    if (usaTotalsElement?.current) {
      const branches = countyBranchesById[normalizedId] ?? 0;
      usaTotalsElement.current.innerText = branches.toLocaleString();
    }
  };

  const handleCountyMouseOut = () => {
    const abbr = selectedStatesAlpha.filter(
      (c) => c.value === appState.filters.stalpbr,
    )[0]?.label;
    if (stateElement?.current) {
      stateElement.current.innerText = abbr || "State";
    }
    if (usaTotalsElement?.current) {
      usaTotalsElement.current.innerText = `${usaTotal.toLocaleString()}`;
    }
  };

  React.useEffect(() => {
    return () => {
      // Clean up the chart instance when the component unmounts
      if (FusionCharts(chartId)) {
        FusionCharts(chartId).dispose();
      }
    };
  }, [chartId]);

  const colorRangeUSA = {
    minvalue: stateMidMax.low,
    startlabel: "Low",
    endlabel: "High",
    code: "#FFFFA2",
    gradient: "1",
    color: [
      {
        maxvalue: stateMidMax.mid,
        code: "#ED4630",
        displayValue: "Middle",
      },
      {
        maxvalue: stateMidMax.max,
        code: "#B2D1FD",
        displayValue: "High",
      },
    ],
  };

  const colorRangeStates = {
    minvalue: countyMidMax.low,
    startlabel: "Low",
    endlabel: "High",
    code: "#FFFFA2",
    gradient: "1",
    color: [
      {
        maxvalue: countyMidMax.mid,
        code: "#ED4630",
        displayValue: "Middle",
      },
      {
        maxvalue: countyMidMax.max,
        code: "#B2D1FD",
        displayValue: "High",
      },
    ],
  };

  const mapChartProps = {
    type: mapType,
    width: "750",
    height: "550",
    dataFormat: "JSON",
    dataSource: {
      chart: {
        animation: "0",
        caption:
          isCountyView && !dontShowCountyData
            ? "Rollover a county for more information"
            : isCountyView && dontShowCountyData
              ? ""
              : "Rollover / click a state for more information",
        entityfillhovercolor: "#EEEEEE",
        showlabels: selectedStateAbbr === "TX" ? "0" : "1",
        borderthickness: "0.4",
        theme: "fusion",
        showLegend: dontShowCountyData ? "0" : "1",
        basefontcolor: "#013a5d",
        entitytooltext: selectedStateAbbr === "GU" ? "Guam" : "<b>$lname</b>",
        numberScaleValue: "1000,1000,1000",
        numberScaleUnit: "K,M,B",
      },

      colorrange: mapType !== "maps/usa" ? colorRangeStates : colorRangeUSA,

      data: isCountyView ? countyMapData : mapData,
    },
    events: isCountyView
      ? {
          entityRollover: (event: KeyValue, data: KeyValue) =>
            handleCountyMouseOver(data.label, data.id),
          entityRollout: () => handleCountyMouseOut(),
          entityClick: (event: KeyValue, data: KeyValue) => {
            if (dontShowCountyData) return;
            let countyName = countyNameByCodeLookup[data.id] ?? data.label;
            if (selectedState === "US Virgin Islands") {
              countyName = data.label;
            }

            updateFilter(
              "county",
              selectedStateAbbr === "GU" ? "Guam" : countyName,
            );
            setMode("table");
          },
          legendRangeUpdated: (eventObj: KeyValue) =>
            handleRangeUpdated(eventObj),
        }
      : {
          entityRollover: (event: KeyValue, data: KeyValue) =>
            handleMouseOver(
              data.label,
              data.shortLabel,
              stateElement,
              usaTotalsElement,
              totalsByState,
            ),
          entityRollout: () =>
            handleMouseOut(stateElement, usaTotal, usaTotalsElement),
          entityClick: (event: KeyValue, data: KeyValue) => {
            const abbr = (data.shortLabel || "").toUpperCase();
            if (!abbr || !getMapType(abbr, appState.ui.year)) return;
            setChartId(`usa-map-${Date.now()}`);
            setSelectedState(data.label);
            setSelectedStateAbbr(abbr);
            setMapType(getMapType(abbr, appState.ui.year));
          },

          legendRangeUpdated: (eventObj: KeyValue) =>
            handleRangeUpdated(eventObj),
        },
  };

  React.useEffect(() => {
    if (!selectedStateAbbr) return;
    const newMapType = getMapType(selectedStateAbbr, appState.ui.year);
    if (newMapType !== mapType) {
      setChartId(`usa-map-${Date.now()}`);
      setMapType(newMapType);
    }
  }, [selectedStateAbbr, appState.ui.year, mapType]);

  React.useEffect(() => {
    updateFilter("stalpbr", selectedStateAbbr || "");
  }, [selectedStateAbbr, updateFilter]);

  React.useEffect(() => {
    if (!isCountyView) {
      setMapType("maps/usa");
      setCountyMapData([]);
    }
  }, [isCountyView]);

  React.useEffect(() => {
    if (!selectedStateAbbr || dontShowCountyData) return;

    let isMounted = true;
    const abbr = selectedStateAbbr.toUpperCase();
    // normalizes county names for virgin islands as they differ by years
    const normalizeVI = (name: string, abbr: string) =>
      abbr === "VI" ? name.replace(/\bSt\.\s+/i, "Saint ") : name;

    const CNTYNUMB = `${ApiBaseUrl()}/sod?filters=STALPBR:"${abbr}"&get_unique=CNTYNUMB&fields=CNTYNUMB,CNTYNAMB&limit=500`;

    (async () => {
      try {
        const [countyCodes] = await Promise.all([fetchData(CNTYNUMB)]);
        let countyNameToId = countyCodes.data.reduce(
          (acc: any, county: any) => {
            acc[county.CNTYNAMB] =
              abbr !== "PR"
                ? String(county.CNTYNUMB).padStart(3, "0")
                : String(county.CNTYNUMB).padStart(2, "0");
            return acc;
          },
          {} as Record<string, string>,
        );
        if (Object.keys(territoryMapping).includes(abbr)) {
          countyNameToId = territoryMapping[abbr];
        }

        const totalsByCountyId: Record<string, number> = mapData.reduce(
          (a, c) => {
            return { ...a, [countyNameToId[c.id]]: c.value };
          },
          {},
        );
        const normalizedToDisplay: Record<string, string> = {};
        if (countyNameToId) {
          for (const countyName of Object.keys(countyNameToId)) {
            normalizedToDisplay[countyName] = countyName;
          }
        }
        const countyMapping = Object.entries(countyNameToId);
        const newMapData: KeyValue[] = countyMapping
          .map(([normalizedName, countyId]: any, index) => {
            return (
              totalsByCountyId[countyId] && {
                id: countyId,
                value: totalsByCountyId[countyId],
                ...(normalizedName && { toolText: `<b>${normalizedName}</b>` }),
              }
            );
          })
          .filter((c) => c);
        if (!isMounted) return;
        const sortedDeposits = Object.values(totalsByCountyId).sort(
          (a, b) => a - b,
        );
        const highestDeposit = sortedDeposits[sortedDeposits.length - 1];
        const lowestDeposit = sortedDeposits.find((val) => val > 0) || 0;

        setCountyMidMax({
          low: lowestDeposit,
          mid:
            highestDeposit === lowestDeposit
              ? highestDeposit / 2
              : (highestDeposit + lowestDeposit) / 2,
          max: highestDeposit,
        });
        setCountyBranchesById(
          Object.fromEntries(newMapData.map(({ id, value }) => [id, value])),
        );
        setCountyMapData(newMapData);
        const countyName = Object.fromEntries(
          countyCodes.data
            .map((county: any) => {
              const normalizedName = normalizeVI(county.CNTYNAMB, abbr);
              const id = countyNameToId[normalizedName];
              return [id, county.CNTYNAMB];
            })
            .filter(([id]: any) => Boolean(id)),
        );
        setCountyNameByCodeLookup(countyName);
      } catch (e) {
        console.error(e);
      } finally {
        isMounted = false;
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [
    selectedStateAbbr,
    appState.filters.lastYear,
    dontShowCountyData,
    mapData,
  ]);

  const showStatesAndTerritories = (minValue: number, maxValue: number) => {
    return (
      <>
        {usStatesAndTerritories.map((territory: KeyValue, index: number) => {
          return (
            <Box
              key={index}
              onMouseOver={() => {
                handleMouseOver(
                  territory.altLabel ? territory.altLabel : territory.label,
                  territory.abbr,
                  stateElement,
                  usaTotalsElement,
                  totalsByState,
                );
              }}
              onClick={() => {
                setChartId(`usa-map-${Date.now()}`);
                setSelectedState(territory.label);
                setSelectedStateAbbr(territory.abbr);
                setMapType(getMapType(territory.abbr, appState.ui.year));
              }}
              onMouseOut={() =>
                handleMouseOut(stateElement, usaTotal, usaTotalsElement)
              }
            >
              <Grid container wrap="nowrap">
                <Grid>
                  <HeatBoxIcon
                    amount={totalsByState[territory.abbr]}
                    rangeMinValue={minValue}
                    rangeMaxValue={maxValue}
                  />
                </Grid>
                <Grid className={classes.territory}>
                  <Typography color="primary.main" variant="body2">
                    {territory.label}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          );
        })}
      </>
    );
  };

  const cardContent = (
    <CardContent>
      <Grid container spacing={1}>
        <Grid size={12}>
          <Grid ref={usaTotalsElement}></Grid>
        </Grid>
        <Grid size={12}>
          <Grid>
            <Typography color="primary.main" variant="body1">
              Branch Offices
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </CardContent>
  );

  React.useEffect(() => {
    const stalpbr = (appState.filters.stalpbr || "").trim();

    if (!stalpbr) {
      setChartId(`usa-map-${Date.now()}`);
      setMode("map");
      setSelectedStateAbbr(null);
      setSelectedState(null);
      setMapType("maps/usa");
      setLegendRangeMinValue(0);
      setLegendRangeMaxValue(3000000000000);
    }
  }, [appState.filters.stalpbr, setMode]);

  React.useEffect(() => {
    if (isCountyView) {
      if (stateElement?.current) {
        const abbr = selectedStatesAlpha.filter(
          (c) => c.value === appState.filters.stalpbr,
        )[0]?.label;
        stateElement.current.innerText = abbr || "State";
      }
    } else if (stateElement?.current) {
      stateElement.current.innerText = "All States and Territories";
    }
    if (usaTotalsElement?.current) {
      usaTotalsElement.current.innerText = `${usaTotal.toLocaleString()}`;
    }
  }, [
    totalsByState,
    isCountyView,
    selectedState,
    selectedStateAbbr,
    usaTotal,
    appState.filters.stalpbr,
  ]);

  // temporarily blocks mouse effects while the map renders
  const [blockHover, setBlockHover] = React.useState(false);
  React.useEffect(() => {
    if (isCountyView) {
      setBlockHover(true);
      const timer = setTimeout(() => setBlockHover(false), 250);
      return () => clearTimeout(timer);
    }
  }, [isCountyView, selectedStateAbbr]);
  return (
    <Root $isCountyView={isCountyView} dontShowCountyData={dontShowCountyData}>
      <Typography color="primary.main" variant="h2" align="center">
        <Grid container spacing={2}>
          <Grid
            size={{
              lg: 9,
              md: 12,
            }}
          >
            <Box
              sx={{
                display: "block",
              }}
            >
              {dontShowCountyData && (
                <>
                  <Typography variant="h4" mt={1.5}>
                    County-level deposits are not applicable to some territory
                    maps.
                  </Typography>
                  <Typography variant="h4" mt={-1.5}>
                    See table view for branch office details
                  </Typography>
                </>
              )}
              {
                // @ts-ignore
                <ReactFC
                  id={chartId}
                  key={`${chartId}-${mapType}-${selectedStateAbbr}`}
                  {...mapChartProps}
                />
              }
              {blockHover && (
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    zIndex: 10,
                    cursor: "default",
                    background: "transparent",
                  }}
                />
              )}
            </Box>
          </Grid>
          <Grid
            size={{
              lg: 3,
              md: 12,
            }}
          >
            <Paper elevation={3} id="map-data-info">
              <Card className={classes.cardDisplay}>
                <CardHeader
                  id="USAMap-summaryDepositsTextBox"
                  ref={stateElement}
                  sx={{
                    position: "relative",
                    color: "white",
                    background: (theme) => theme.palette.primary.main,
                    fontSize: "1.25rem",
                    padding: ".5rem",
                  }}
                ></CardHeader>
                {cardContent}
              </Card>
            </Paper>
            <br />
            {!isCountyView && (
              <>
                {" "}
                <Grid>
                  <Typography
                    color="primary.main"
                    className={classes.statesHeading}
                  >
                    States & Territories not depicted
                  </Typography>
                </Grid>
                {showStatesAndTerritories(
                  legendRangeMinValue,
                  legendRangeMaxValue,
                )}
              </>
            )}
          </Grid>
        </Grid>
      </Typography>
    </Root>
  );
}
